import MegaMenu from './MegaMenu';
const el = document.querySelector('.mega-menu');

if (el) {
    MegaMenu(el);
}
